import { notificationsData } from "assets/dummyData/notifications";
import NotificationItem from "pages/AdminView/AdminDashboardPage/components/AdminDashboardRecentActivity/NotificationItem";
import React from "react";

export default function ClientNotificationsList() {
  const containerStyles = "mb-[30px] bg-white rounded-xl shadow-md blur-2 text-opacity-15 spread-0";

  return (
    <div className={containerStyles}>
      <section className="p-6">
        <h2 className="font-bold text-xl mb-4">Notifications</h2>
        {notificationsData.map((notification) => (
          <NotificationItem key={notification.notificaitonId} notification={notification} />
        ))}
       </section>
    </div>
  );
}
